import { React } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PassField from '../Inputs/PassField';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import axios from '../../axios';
import Swal from 'sweetalert2';

export default function ResetPasswordStepThree({userEmail}) {
  const validationSchema = Yup.object().shape({
    password: Yup.string().min(8,'Password must contain atleast 8 characters').required('Required')
  });
  const navigate = useNavigate();

  const saveNewPassword = (values, setSubmitting) => {
    values.email = userEmail;
    axios.post('/reset-password', values)
    .then((response) => {
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Password Reset Successfully!',
          showConfirmButton: false,
          timer: 2000,
          padding: '2em',
          allowOutsideClick: false
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            navigate('/login');
          }
        });
      } else {
        toast.warn('No response from server');
      }
      setSubmitting(false);
    })
    .catch((error) => {
      toast.error('Something went wrong');
      setSubmitting(false);
    })
  };

  return (
    <div className='pass-reset-step3'>
      <h1 className='mb-4'>Create New Password</h1>
      <Formik
        initialValues={{
          password: ''
        }}
        validationSchema={validationSchema}
        onSubmit={(values, {setSubmitting}) => saveNewPassword(values, setSubmitting)}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          isSubmitting
        }) => (
          <Form className='forms'onSubmit={handleSubmit}>
            <div className='mb-3'>
              <PassField 
                placeholder='Enter your new password'
                name='password'
                value={values.password}
                onChange={handleChange}
                isSubmitting={isSubmitting} 
              />
            </div>
            <Button type='submit' variant='primary' className='btn-full-width my-3' disabled={isSubmitting}>
              Submit 
              {
                isSubmitting &&
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className='ms-2'
                />
              }
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  )
}
